export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function hasKeys(record: Record<string, unknown>): boolean {
  return Object.keys(record).length > 0;
}

/** Build a type guard that checks membership of a value in a fixed set of string literals. */
export function makeMembershipGuard<T extends string>(
  values: readonly T[],
): (value: unknown) => value is T {
  const allowed = new Set<string>(values);
  return (value: unknown): value is T => typeof value === 'string' && allowed.has(value);
}
